<template>
  <div
    class="color-header"
    :style="{ backgroundColor: headerBackgroundColor }"
  >
    <icon-component
      v-if="showHcpLogo"
      name="hcp_connect_badge"
      class="color-header__badge"
    />
    <span
      v-else-if="versatileLabel"
      :style="{ backgroundColor: labelBackgroundColor, color: labelTextColor }"
      class="color-header__label"
    >
      {{ versatileLabel }}
    </span>
    <h1 v-if="title" class="color-header__title" :style="{ color: titleTextColor }">
      {{ title }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'ColorHeader',
  props: {
    postMetas: {
      type: Object,
      required: true,
    },
  },
  computed: {
    headerBackgroundColor() {
      return this.postMetas.color_header_bg_color;
    },
    title() {
      return this.postMetas.color_header_title;
    },
    versatileLabel() {
      return this.postMetas.color_header_versatile_label;
    },
    labelBackgroundColor() {
      return this.postMetas.color_header_label_bg_color;
    },
    titleTextColor() {
      return this.postMetas.color_header_heading_text_color || '#ffffff';
    },
    labelTextColor() {
      return this.postMetas.color_header_label_text_color || '#ffffff';
    },
    showHcpLogo() {
      return this.postMetas.color_header_show_hcp_logo === '1';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_color-header';
</style>
